import React from "react";
import { Box } from "@mui/material";
import { ACCENT, SURFACE, TEXT } from "../../../../dark-theme/palette";

/**
 * Renders hint pattern as a row of squares: "-" = empty box, A–Z = letter in box.
 * @param {string} pattern - e.g. "---R----"
 * @param {number} boxSize - px width/height of each cell
 */
export default function HintPatternBoxes({ pattern, boxSize = 20 }) {
    if (!pattern || typeof pattern !== "string") {
        return null;
    }
    const chars = pattern.split("");
    return (
        <Box
            role="img"
            aria-label="Hint letter positions"
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                alignItems: "center",
                justifyContent: "flex-start"
            }}
        >
            {chars.map((ch, i) => {
                const isEmpty = ch === "-" || ch === "\u25CB"; // dash or legacy circle
                return (
                    <Box
                        key={i}
                        sx={{
                            width: boxSize,
                            height: boxSize,
                            minWidth: boxSize,
                            minHeight: boxSize,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid",
                            borderColor: isEmpty ? SURFACE.borderStrong : ACCENT.main,
                            borderRadius: 0.5,
                            bgcolor: isEmpty ? SURFACE.sunken : ACCENT.soft,
                            fontSize: Math.max(11, boxSize * 0.5),
                            fontWeight: 700,
                            fontFamily: "ui-monospace, monospace",
                            color: TEXT.primary,
                            flexShrink: 0,
                            boxSizing: "border-box"
                        }}
                    >
                        {isEmpty ? "" : ch.toUpperCase()}
                    </Box>
                );
            })}
        </Box>
    );
}
